import { useEffect, useState } from 'react';

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkTablet = () => {
      if (typeof window === 'undefined') return;
      // Tablet breakpoint is typically 768px to 1024px, but we'll use 1200px as the desktop breakpoint
      setIsTablet(window.innerWidth < 1200);
    };

    checkTablet();
    window.addEventListener('resize', checkTablet);
    return () => window.removeEventListener('resize', checkTablet);
  }, []);

  return isTablet;
};
